import type {
  EventBusCallback,
  EventBusContract,
  EventBusSubscriberMap,
  EventBusSubscribers,
} from './eventBus.types'

export class EventBus implements EventBusContract {
  protected subscribers: EventBusSubscribers = {}

  protected nextId(): symbol {
    return Symbol('')
  }

  protected subscriberGet(name: string): EventBusSubscriberMap {
    let subscriber = this.subscribers[name]
    if (subscriber) return subscriber
    subscriber = new Map()
    this.subscribers[name] = subscriber
    return subscriber
  }

  public on(name: string, callback: EventBusCallback): void {
    const subscriber = this.subscriberGet(name)
    const id = this.nextId()
    subscriber.set(id, callback)
  }

  public off(name: string, callback?: EventBusCallback): void {
    if (!this.subscribers[name]) return
    const subscriber = this.subscriberGet(name)
    if (callback) {
      subscriber.forEach((cb, id) => {
        if (cb === callback) subscriber.delete(id)
      })
    } else {
      Reflect.deleteProperty(this.subscribers, name)
    }
  }

  public emit<T>(name: string, payload?: T): void {
    if (!this.subscribers[name]) return
    const subscriber = this.subscriberGet(name)
    subscriber.forEach((callback) => callback(payload as never))
  }

  public nameGenerate(context: string, target: string, command: string): string {
    return `${context}:${target}:${command}`
  }
}

export const eventBus = new EventBus()
